import { takeLatest, put, call, cancelled, select } from 'redux-saga/effects';
import instance from 'services/request';
import { getTradeAgreementsSellOutValidatorsCatalog } from 'RootModule/services/tradeAgreementsSellOutValidators';
import { responseOK } from 'Domains/TradeAgreements/utils';
import {
  TRADE_AGREEMENTS_SELLOUT_VALIDATORS_CATALOG_REQUEST,
  tradeAgreementsSellOutValidatorsCatalogSuccess,
  tradeAgreementsSellOutValidatorsCatalogFail,
} from '../actions/tradeAgreementsSellOutValidators';
import { messageError } from 'utils/messages';

function* workTradeAgreementsSellOutValidatorsRequest(action) {
  const CancelToken = instance.CancelToken;
  const source = CancelToken.source();
  const { payload } = action;
  const { params } = payload;
  const query = yield select((state) => state?.VALIDATIONS?.filters?.query);
  const { clientId } = query;
  try {
    let requestConfig = {
      cancelToken: source.token,
      name: 'Clients',
      params: params,
    };
    requestConfig = { ...requestConfig, name: 'Clients' };
    const response = yield call(getTradeAgreementsSellOutValidatorsCatalog, requestConfig);
    if (responseOK(response)) {
      const filteredData = response.data.filter((item) => {
        for (let index = 0; index < clientId.length; index++) {
          let foundIndex = item.clients.findIndex((el) => {
            return el.clientId === clientId[index];
          });

          if (foundIndex === -1) {
            return true;
          }
        }
        return false;
      });
      const hasError = response.data.length === 0;
      yield put(tradeAgreementsSellOutValidatorsCatalogSuccess(filteredData));
      if (hasError) messageError(response.message);
    } else {
      yield put(tradeAgreementsSellOutValidatorsCatalogFail());
    }
  } catch (e) {
    yield put(tradeAgreementsSellOutValidatorsCatalogFail());
  } finally {
    if (yield cancelled()) {
      source.cancel('cancelled Request ');
    }
  }
}

export function* watchSellOutValidatorsRequest() {
  yield takeLatest(
    TRADE_AGREEMENTS_SELLOUT_VALIDATORS_CATALOG_REQUEST,
    workTradeAgreementsSellOutValidatorsRequest
  );
}
